// Platform-wide roles. Office membership (which office a user belongs to)
// is separate and lives in the auth organization tables.
export const PLATFORM_ROLES = ["admin", "partner", "office"] as const;
export type PlatformRole = (typeof PLATFORM_ROLES)[number];

export const ROLE_LABELS: Record<PlatformRole, string> = {
  admin: "システム管理者",
  partner: "営業・進行",
  office: "事務所の担当者",
};

/** Roles that may act across offices they are assigned to (admin: all offices). */
export function isStaff(role: PlatformRole): boolean {
  return role === "admin" || role === "partner";
}

/**
 * Administrators fixed in code: the service's owner and its sales partner.
 * The screens can neither delete these accounts nor change their role; to
 * release one, remove the address here and release a new version.
 */
export const PROTECTED_ADMIN_EMAILS = ["i.amaoto0906@gmail.com", "h-takaoka@dho.jp"] as const;

export function isProtectedAdmin(email: string): boolean {
  return (PROTECTED_ADMIN_EMAILS as readonly string[]).includes(email.trim().toLowerCase());
}

/**
 * The service's owner. On top of the protection above, no other
 * administrator may reset the owner's password or 2FA, or change the
 * owner's offices: only the owner, or someone with shell access to the
 * server (npm run reset-two-factor), can.
 */
export const OWNER_EMAILS = ["i.amaoto0906@gmail.com"] as const;

export function isOwner(email: string): boolean {
  return (OWNER_EMAILS as readonly string[]).includes(email.trim().toLowerCase());
}

/**
 * 見本 offices (made by seed-demo for sales demos) are named with this
 * prefix. Their numbers are sample rows; the daily Google reads skip them.
 */
export const DEMO_OFFICE_PREFIX = "見本：";

export function isDemoOffice(name: string): boolean {
  return name.startsWith(DEMO_OFFICE_PREFIX);
}
